/**
 * Unlock Catalog — prices for tanks and colors.
 *
 * Tanks not listed here are default (always unlocked).
 * Colors matching any tank's default bodyColor are free.
 */

export const TANK_PRICES: Record<string, number> = {
  scatter: 300,
  terraformer: 300,
  duelist: 500,
  vortex: 500,
  gyro: 500,
};

export const COLOR_PRICE = 100;

/** Coin awards per game outcome. */
export const COIN_AWARD = {
  WIN: 300,
  LOSS: 100,
  TUTORIAL: 200,
  SURVIVAL_BASE: 50,
  SURVIVAL_PER_KILL: 15,
  ROGUELITE_PER_ZONE: 50,
  ASCENT_COMPLETE: 150,
  ASCENT_DEATH: 50,
  TARGET_BLAST_COMPLETE: 75,
  TARGET_BLAST_NEW_BEST: 50,
  GRADE_S_BONUS: 100,
  GRADE_A_BONUS: 50,
} as const;
